import { getOrderId } from './payment-utils';
import { scrollToElement } from './payment';

const BILLING_ADDRESS = 'billing-address-details';
const typeCurrentClass = 'fapiao-type--current';

let fapiaoInvoiceSelect;
let billingAddress;

export function init() {
  fapiaoInvoiceSelect = $('#fapiao-invoice');
  billingAddress = $('#billing-address');
  $('#fapiao-customer-mail').blur(testEmail);
  $('#fapiao-customer-phone').blur(testPhone);
  $('#header-fapiao').blur(testTitle);
  $('#fapiao-registration-number').blur(testTaxRegistrationNumber);

  const fapiaoSelect = $('select#fapiao-invoice, select#fapiao-content');
  if (!$('body').hasClass('mobile')) {
    fapiaoSelect.selectpicker('refresh');
  } else {
    fapiaoSelect.selectpicker('mobile');
  }

  $('[name=rb-fapiao-type]').change(function onChanges() {
    $('#fapiao-form-type').val($(this).val());
    // hide or display the company efapiao panel
    const companyFapiaoPanel = $('.company-registry-efapiao');
    if ($(this).val() === 'efapiao') {
      companyFapiaoPanel.addClass(typeCurrentClass);
    } else {
      companyFapiaoPanel.removeClass(typeCurrentClass);
    }

    $('.fapiao-type[data-fapiao]').removeClass(typeCurrentClass);
    $(`.fapiao-type[data-fapiao=${$(this).val()}]`).addClass(typeCurrentClass);
  });

  // force to update billing address panel display
  if ($('#fapiao-form-type').val() === 'fapiao' && fapiaoInvoiceSelect.val() !== 'noselection') {
    billingAddress.addClass(typeCurrentClass);
  } else {
    billingAddress.removeClass(typeCurrentClass);
  }

  $('#fapiao-block .panel-heading').on('click', resetFapiao);

  $('[id ^=fapiao][id $=note], [id ^=fapiao][id $=informations], .fapiao-content')
    .hide()
    .stop();
  reloadFapiao(fapiaoInvoiceSelect.val());

  fapiaoInvoiceSelect.change(() => {
    let formType = $('#fapiao-form-type').val();
    if (formType === 'twice') {
      formType = '@form_type';
    }
    refreshFapiaoTypeFromCartridge(fapiaoInvoiceSelect.val(), formType);
  });

  $('input[type=radio][name=rb-fapiao-type]').change(function onChange() {
    refreshFapiaoTypeFromCartridge(fapiaoInvoiceSelect.val(), $(this).val());
  });

  initBillingCartridge();
}

function initBillingCartridge() {
  $(`#${BILLING_ADDRESS}`)
    .on('click', '#bt-back-address', e => {
      e.preventDefault();
      refreshFapiaoBillingFromCartridge();
    })
    .on('change', 'input[type="radio"][name="address-choose"]', function onChange() {
      const selectedAddressId = $(this).attr('id');
      refreshFapiaoBillingFromActor(selectedAddressId);
    });

  $('#changeBillingAddressBtn').on('click', (e) => {
    e.preventDefault();
  });
}

function refreshFapiaoTypeFromCartridge(selectedType, fapiaoFormType) {
  $('#content-fapiao')
    .attr('data-t-url-actor', '/com/decathlon/cube/commerce/payment/PaymentActor/changeFapiaoType')
    .attr('data-t-path', 'checkout.payment.ch_fapiao')
    .attr('data-t-url', '/content/zTechnical Content/Billing Content/Fapiao');

  const params = { 'selectedType': selectedType, 'fapiaoFormType': fapiaoFormType, 'orderId': window.tc_vars.order_id };

  window.reloadCartridgeFromActor(
    $(this),
    'content-fapiao',
    params,
    () => {
      $('.selectpicker').selectpicker('render');

      if ($('#fapiao-form-type').val() === 'fapiao' && fapiaoInvoiceSelect.val() !== 'noselection') {
        billingAddress.addClass(typeCurrentClass);
      } else {
        billingAddress.removeClass(typeCurrentClass);
      }

      init();
    }
  );
}

function refreshFapiaoBillingFromCartridge() {
  window.reloadCartridgeContentCollection($(this), BILLING_ADDRESS, undefined, init);
}

function refreshFapiaoBillingFromActor(selectedAddressId) {
  const params = { 'selectedAddressId': selectedAddressId, 'orderId': getOrderId() };

  let PATH_SHIPPING_ADDRESS = 'checkout.shipping.ch_shippingaddress';
  const country = $('#billing-address').data('country');
  if (country === 'CN') {
    PATH_SHIPPING_ADDRESS = `${PATH_SHIPPING_ADDRESS}_${country}`;
  }

  $('#address-book')
    .attr('data-t-path', PATH_SHIPPING_ADDRESS)
    .attr('data-t-url', '/content/zTechnical Content/Billing Content/BillingAddress');

  window.reloadCartridgeFromActor($(this), BILLING_ADDRESS, params, init);
}

function reloadFapiao(fapiaoType) {
  // hide notes and forms & remove event handler
  $('[id ^=fapiao][id $=note], [id ^=fapiao][id $=informations]').hide().stop();

  if (fapiaoType !== 'noselection') {
    $('#fapiao-content-div, #billing-address').show();
    const fapiaoTypeInput = $(`#fapiao-${fapiaoType}-informations input`);
    fapiaoTypeInput.unbind('keyup');
    // display note and form for selected invoice type
    $(`#fapiao-${fapiaoType}-note, #fapiao-${fapiaoType}-informations`).show().stop();
    fapiaoTypeInput.keyup(function onKeyUp(event) {
      const key = (event.keyCode || event.which);
      if ($(this).val().length !== 0) {
        $(this).parent().removeClass('has-error');
      } else if (key <= 90 && key >= 48 || key === 8 || key === 46) {
        $(this).parent().addClass('has-error');
      }
    });
  } else {
    $('#fapiao-content-div').hide();
    billingAddress.hide();
  }
  // Clear error
  $('#fapiao-block .form-group').removeClass('has-error');
}

function resetFapiao() {
  const isCollapsedBeforeClick = $(this).hasClass('collapsed');
  if (!isCollapsedBeforeClick && fapiaoInvoiceSelect.val() !== 'noselection') {
    //we close the panel
    fapiaoInvoiceSelect.val('noselection').change();
  }
}

function testEmail() {
  const customerMailInput = $('#fapiao-customer-mail');
  if (customerMailInput.length > 0 && customerMailInput.is(':visible') === true) {
    const email = customerMailInput.val().trim();
    customerMailInput.val(email);
    const testEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email !== '' && testEmailRegex.test(email) === true) {
      customerMailInput.parents('.form-group').removeClass('has-error');
      return true;
    }
    customerMailInput.parents('.form-group').addClass('has-error');
    scrollToElement(customerMailInput);
    return false;
  }
  return true;
}

function testPhone() {
  const phoneInput = $('#fapiao-customer-phone');
  if (phoneInput.length > 0 && phoneInput.is(':visible') === true) {
    const phone = phoneInput.val().trim();
    phoneInput.val(phone);
    const testPhoneRegex = /^1[0-9]{10}$/;

    if (phone !== '' && testPhoneRegex.test(phone) === true) {
      phoneInput.parents('.form-group').removeClass('has-error');
      return true;
    }
    phoneInput.parents('.form-group').addClass('has-error');
    scrollToElement(phoneInput);
    return false;
  }
  return true;
}

function testFieldNotEmpty(fieldSelector) {
  const input = $(fieldSelector);
  if (input.length > 0 && input.is(':visible') === true) {
    const title = input.val().trim();
    input.val(title);

    if (title !== '') {
      input.parents('.form-group').removeClass('has-error');
      return true;
    }
    input.parents('.form-group').addClass('has-error');
    scrollToElement(input);
    return false;
  }
  return true;
}

function testTitle() {
  return testFieldNotEmpty('#header-fapiao');
}

function testTaxRegistrationNumber() {
  return testFieldNotEmpty('#fapiao-registration-number');
}

export function isFapiaoValid() {
  return testEmail() && testPhone() && testTitle() && testTaxRegistrationNumber();
}



// WEBPACK FOOTER //
// ./src/checkout/payment/fapiao.js